import { createPinia } from 'pinia'
import { getCurrentUserApi } from '@/service/api/users'
import { setToken as _setToken, getToken, removeToken } from '@/utils/cache/cookies'
import { ref } from 'vue'
import { defineStore } from 'pinia'
import { setObjTypeStorage } from '@/utils'

export const useUserStore = defineStore('user', () => {
  const token = ref(getToken() || '')
  const roles = ref([])
  const username = ref('')
  const userInfo = ref(null)
  const deviceInfo = ref(null)
  const locationInfo = ref(null)
  const statusBarHeight = ref(20)

  // 设置用户信息
  const setUserInfo = info => {
    if (!info) return
    userInfo.value = info
    const { mobile, loginToken, memberId, loginId } = info
    setObjTypeStorage(
      'userInfo',
      {
        mobile,
        memberId,
        loginId,
        loginToken,
      },
      true
    )
    sessionStorage.setItem('mobile', mobile)
    sessionStorage.setItem('loginToken', loginToken)
    sessionStorage.setItem('memberId', memberId)
  }

  // 设置设备信息
  const setDeviceInfo = info => {
    deviceInfo.value = info
  }

  // 设置 Token
  const setToken = value => {
    _setToken(value)
    token.value = value
  }

  // 获取用户详情
  const getInfo = async () => {
    const { data } = await getCurrentUserApi()
    username.value = data.username
    roles.value = data.roles
  }

  const changeRoles = role => {
    const newToken = `token-${role}`
    token.value = newToken
    _setToken(newToken)
    // 用刷新页面代替重新登录
    location.reload()
  }

  // 重置 Token
  const resetToken = () => {
    removeToken()
    token.value = ''
    roles.value = []
  }
  const setStatusBarHeight = height => {
    statusBarHeight.value = height // 设置状态栏高度
  }

  const setLocationInfo = location => {
    locationInfo.value = location
    const { cityId, cityName, isAbroad } = location
    sessionStorage.setItem('cityId', cityId)
    sessionStorage.setItem('cityName', cityName) + sessionStorage.setItem('isAbroad', isAbroad)
  }

  return {
    token,
    roles,
    username,
    userInfo,
    deviceInfo,
    statusBarHeight,
    locationInfo,
    setToken,
    getInfo,
    changeRoles,
    resetToken,
    setUserInfo,
    setDeviceInfo,
    setStatusBarHeight,
    setLocationInfo,
  }
})

/**
 * @description 在 SPA 应用中可用于在 pinia 实例被激活前使用 store
 * @description 在 SSR 应用中可用于在 setup 外使用 store
 */
export function useUserStoreOutside() {
  return useUserStore(createPinia())
}
